import myaxios from "../../components/Axios";

export const getAllUsersService = () => myaxios.get(`/ajax/settings/user`);